import { Box } from '@mui/material';

import { CopyToClipboardButton } from '@/components/buttons/copyToClipboardButton';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { JsonViewer } from '@/components/shared/jsonViewer';

export const JsonDialog = ({
  isOpen,
  onClose,
  title,
  data,
  closeTestId,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  data: object;
  closeTestId: string;
}) => (
  <MainDialog
    isOpen={isOpen}
    isLoading={false}
    header={{ title, onClose }}
    footer={{
      primaryButton: {
        text: 'Close',
        onClick: onClose,
        'data-testid': closeTestId,
      },
      children: (
        <CopyToClipboardButton
          textToCopy={JSON.stringify(data)}
          buttonLabel='Copy'
        />
      ),
    }}
  >
    <Box
      className='px-[40px]'
      sx={{
        minHeight: '350px',
        maxHeight: '80%',
        overflow: 'auto',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        '& *': {
          backgroundColor: 'transparent !important',
        },
        '& ul > div': {
          paddingLeft: '28px',
        },
        '& [role="treeitem"]': {
          lineHeight: '20px',
        },
        '& [role="button"]': {
          marginLeft: '-14px',
        },
      }}
    >
      <JsonViewer data={data} />
    </Box>
  </MainDialog>
);
